import axios from 'axios'
import store from '@/store'
import router from '@/router'

const http = axios.create({
  baseURL: process.env.VUE_APP_API_BASE
})

http.interceptors.request.use(
  config => {
    const source = axios.CancelToken.source()
    config.cancelToken = source.token
    store.commit('global/ADD_CANCEL_TOKEN', source)
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

http.interceptors.response.use(
  response => {
    return response
  },
  error => {
    // A request cancelled by router.beforeEach (CANCEL_PENDING_REQUESTS) carries
    // neither response nor config, and neither does a network timeout. Reading
    // error.response.status straight away threw a TypeError from inside the
    // interceptor, which then replaced the real error and left every caller
    // blind to what had actually happened.
    if (axios.isCancel(error)) {
      return Promise.reject(error)
    }
    const status = error.response && error.response.status
    const url = (error.config && error.config.url) || ''
    if (!status) {
      return Promise.reject(error)
    }
    if (status === 403) {
      return router.push({name: 'PermissionDenied'})
    }
    if (status === 401 && url.endsWith('/token/refresh/')) {
      return store.commit('auth/DELETE_AUTH', {
        router: router,
        redirect: router.currentRoute.fullPath
      })
    }
    if ((status === 401 && url.endsWith('/token/')) || status !== 401) {
      return new Promise((resolve, reject) => {
        reject(error)
      })
    }
    return store.dispatch('auth/REFRESH_TOKEN')
    .then((response) => {
      return new Promise((resolve, reject) => {
        http.request(error.config)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
      })
    })
    .catch((error) => {
      Promise.reject(error)
    })
  }
)

export default http
